import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const imp = params.get("imp");
    if (imp) {
      localStorage.setItem("gf_token", imp);
      window.history.replaceState({}, "", window.location.pathname);
    }
    const ref = params.get("ref");
    if (ref) localStorage.setItem("gf_ref", ref.toUpperCase().trim());
    const token = localStorage.getItem("gf_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("gf_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gf_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("gf_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const retailerSignup = async (payload) => {
    const { data } = await api.post("/auth/retailer/signup", payload);
    localStorage.setItem("gf_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("gf_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, retailerSignup, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
